import { Box, Text, Heading } from '@primer/react';
import Reveal from './Reveal';

function PageHero({ title, subtitle }) {
  return (
    <Box
      sx={{
        backgroundColor: 'canvas.default',
        backgroundImage:
          'radial-gradient(circle at 18% 0%, rgba(96, 165, 250, 0.24), transparent 55%), radial-gradient(circle at 82% 25%, rgba(167, 139, 250, 0.2), transparent 55%)',
        paddingTop: [8, 9, '14vh'],
        paddingBottom: [7, 8, 9],
        paddingX: ['24px', '48px', '100px'],
      }}
    >
      <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
        <Reveal direction="left" distance={40}>
          <Heading
            as="h1"
            sx={{
              margin: 0,
              marginBottom: 5,
              maxWidth: '780px',
              fontFamily: "'Fraunces', serif",
              fontWeight: 300,
              fontSize: ['2.5rem', '3.5rem', '4.5rem'],
              lineHeight: 1.15,
              color: 'fg.default',
            }}
          >
            {title}
          </Heading>
        </Reveal>

        <Reveal direction="left" distance={40} delay={0.1}>
          <Text
            as="p"
            sx={{
              margin: 0,
              maxWidth: '620px',
              fontSize: 2,
              lineHeight: 1.7,
              color: 'fg.muted',
            }}
          >
            {subtitle}
          </Text>
        </Reveal>
      </Box>
    </Box>
  );
}

export default PageHero;
